import API from "../../api";
import { API_USER_MASTER_SEARCH } from "../../constants/api";

const searchUsers = async (data) => {
  try {
    const response = await API.get(API_USER_MASTER_SEARCH, {
      params: data,
    });
    return response.data;
  } catch (e) {
    throw e.response
  }
};

const SearchScreen = {
  searchUsers,
};

export {
  SearchScreen as default,
  searchUsers,
}
